import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0cb59b98&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb59b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb59b98')) {
      api.createRecord('0cb59b98', component.options)
    } else {
      api.reload('0cb59b98', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0cb59b98&scoped=true", function () {
      api.rerender('0cb59b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectLocalLoad/index.vue"
export default component.exports